import { useAdapterContext } from '../../utils/adapters';
import { PlainNavigationItemProps } from './PlainNavigationItem';

export function NavigationItem<TComponentProps>(
  props: TComponentProps extends object
    ? Omit<PlainNavigationItemProps, 'component' | keyof TComponentProps> & TComponentProps
    : Omit<PlainNavigationItemProps, 'component' | keyof MdsNavigationItemProps> & MdsNavigationItemProps,
) {
  const { NavigationItemComponent } = useAdapterContext();
  return <NavigationItemComponent {...(props as any)} />;
}
